module.exports = __webpack_public_path__ + "img/avatar4.ad2dd2d0.png";